import { useAuth } from "../contexts/AuthContext";
import { Clock, LogOut } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f7f6] px-4">
      <div className="w-full max-w-md bg-white border border-[#E5E5E5] rounded-md p-8 text-center">
        <div className="w-12 h-12 mx-auto bg-[#FEFCE8] border border-[#FEF08A] rounded-md grid place-items-center mb-5">
          <Clock className="w-5 h-5 text-[#CA8A04]" />
        </div>
        <h1 className="font-display text-xl font-bold mb-2">
          Awaiting admin approval
        </h1>
        <p className="text-sm text-[#525252] mb-2">
          Your store request was submitted. You'll be able to sign in once an
          admin approves your account.
        </p>
        {user && user.email && (
          <p className="text-xs font-mono-tabular text-[#525252] mb-6">
            {user.email}
          </p>
        )}
        <button
          onClick={logout}
          className="inline-flex items-center gap-2 px-4 py-2 border border-[#E5E5E5] rounded-md text-sm hover:bg-[#FAFAFA]"
          data-testid="pending-logout"
        >
          <LogOut className="w-3.5 h-3.5" /> Sign out
        </button>
      </div>
    </div>
  );
}
